import { Component } from '@angular/core';

@Component({
  selector: 'ssp-page-layout',
  templateUrl: './pagelayout.component.html',
  styleUrls: ['./pagelayout.component.scss']
})
export class PageLayoutComponent {

}